import { createContext, useContext } from 'react';

import type {
  SingleValueConfigProperties,
  SingleValueProps,
} from '../types/single-value.js';
import type { SingleValueSlots } from '../utils/iterate-slots.js';
import {
  buildSingleValueConfig,
  deserializeConfig,
  isSerializedConfig,
} from '../utils/single-value-config.js';

/**
 * @internal
 */
export const SingleValueConfigContext = createContext<
  SingleValueConfigProperties | string
>({});

/**
 * Provider for the SingleValue API config that can be shared across charts
 * @public
 */
export const SingleValueConfig = SingleValueConfigContext.Provider;

/**
 * @internal
 */
export const useSingleValueConfig = (
  props: Omit<SingleValueProps, 'data' | 'prefixIcon'>,
  slots: SingleValueSlots,
): SingleValueConfigProperties => {
  let contextConfig = useContext(SingleValueConfigContext);

  if (isSerializedConfig(contextConfig)) {
    contextConfig = deserializeConfig(contextConfig);
  }

  return buildSingleValueConfig(props, slots, contextConfig);
};
